import com.mmk.kmpnotifier.KMPNotifier
import kotlinx.browser.window
import kotlinx.coroutines.await
import org.w3c.fetch.RequestInit
import com.bikompanion.ui.settings.NotificationControls
import com.bikompanion.ui.settings.NotificationStatus

/** Null in a browser without the Notification API, such as iOS Safari outside a home screen app. */
fun browserNotificationControls(): NotificationControls? {
    browserNotificationPermission() ?: return null
    return NotificationControls(
        status = {
            when (browserNotificationPermission()) {
                "granted" -> NotificationStatus.Allowed
                "denied" -> NotificationStatus.Blocked
                else -> NotificationStatus.Off
            }
        },
        manage = { onDone -> KMPNotifier.permissionUtil.askNotificationPermission { onDone() } },
    )
}

private fun browserNotificationPermission(): String? = window.asDynamic().Notification?.permission as? String

suspend fun loadBrowserLicenses(): String {
    // Not `RequestInit()`, whose unset fields arrive as null and fail the browser's enum checks.
    val response = window.fetch("aboutlibraries.json", js("({})").unsafeCast<RequestInit>()).await()
    check(response.ok) { "aboutlibraries.json answered ${response.status}" }
    return response.text().await()
}
